import { render } from "./PurposeItem.vue?vue&type=template&id=059bbe0b&scoped=true&ts=true"
import script from "./PurposeItem.vue?vue&type=script&lang=ts"
export * from "./PurposeItem.vue?vue&type=script&lang=ts"

import "./PurposeItem.vue?vue&type=style&index=0&id=059bbe0b&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059bbe0b"]])

export default __exports__